import {
    ACCEPT_MASS_ACTIONS_CALLOUTS,
    BannersEditMassActions,
    CHANGE_MASS_ACTIONS_CALLOUTS_RADIO_STATE,
    CLOSE_MASS_ACTIONS_CALLOUTS,
    ON_OPEN_MASS_ACTIONS_CALLOUTS
} from '../../../actions/banners-edit/banners-edit-mass-actions';
import { BannersEditMassActionsState } from '../../../typings/bannersEditState';
import { State } from '../../../typings/state';

import { bannersEditMassActionsInitialState } from './banners-edit-mass-actions';

export function bannersEditMassActionsCalloutsReducer(
    state: BannersEditMassActionsState = bannersEditMassActionsInitialState,
    action: BannersEditMassActions,
    fullState: State
): BannersEditMassActionsState {
    switch (action.type) {
        case ACCEPT_MASS_ACTIONS_CALLOUTS:
            return bannersEditMassActionsInitialState;
        case ON_OPEN_MASS_ACTIONS_CALLOUTS:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    visibleModalActions: {
                        ...state[action.massActionId].visibleModalActions,
                        calloutsEditorVisible: true
                    }
                }
            };
        case CLOSE_MASS_ACTIONS_CALLOUTS:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    visibleModalActions: {
                        ...state[action.massActionId].visibleModalActions,
                        calloutsEditorVisible: false
                    }
                }
            };
        case CHANGE_MASS_ACTIONS_CALLOUTS_RADIO_STATE:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        ...state[action.massActionId].data,
                        currentCalloutsRadioState: action.value
                    }
                }
            };
        default:
            return state;
    }
}
